import {useEffect, useCallback, useState, useRef} from 'react';
import {VirtuosoHandle} from 'react-virtuoso';
import {LocalEventEmitter} from '@kcast-fe/core';

const useChatScroll = () => {
  const vRef = useRef<VirtuosoHandle | null>(null);
  const cRef = useRef<HTMLDivElement | null>(null);

  const [isScrolledToEnd, setIsScrolledToEnd] = useState(true);

  const scrollToBottom = useCallback(
    (behavior?: ScrollBehavior) => {
      cRef?.current?.scrollTo({behavior, top: cRef.current.scrollHeight});
    },
    [cRef]
  );

  const handleOnScroll = useCallback(() => {
    const scrollHeight = cRef?.current?.scrollHeight ?? 0;
    const clientHeight = cRef?.current?.clientHeight ?? 0;
    const scrollPosition = cRef?.current?.scrollTop ?? 0;
    const diff = scrollHeight - (clientHeight + scrollPosition);
    setIsScrolledToEnd(diff < 10);
  }, [cRef]);

  useEffect(() => {
    const onScroll = () => {
      if (isScrolledToEnd) {
        scrollToBottom();
      }
    };
    LocalEventEmitter.on('ChatScrollToEnd', onScroll);
    return () => {
      LocalEventEmitter.off('ChatScrollToEnd', onScroll);
    };
  }, [isScrolledToEnd, scrollToBottom]);

  useEffect(() => {
    let refCopy = null;
    if (cRef.current) {
      refCopy = cRef.current;
      refCopy.addEventListener('scroll', handleOnScroll);
    }
    return () => {
      refCopy?.removeEventListener('scroll', handleOnScroll);
    };
  }, [cRef, handleOnScroll]);

  return {vRef, cRef, isScrolledToEnd, scrollToBottom};
};

export {useChatScroll};
